module.exports = __webpack_public_path__ + "img/part4-uIcon19.dc2dddf6.png";